import type { IconSvgObject } from './types';

const Chemistry02Icon: IconSvgObject = [
  ["path", { d: "M3 9H11.5M21 9H15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 3V19C5 20.1046 5.89543 21 7 21H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10.5 4H16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M11.5 4V9L8.61286 15.5992C8.32381 16.2599 8.80786 17 9.52902 17H17.471C18.1921 17 18.6762 16.2599 18.3871 15.5992L15.5 9V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Chemistry02Icon;
